import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { useTheme, useLoyalty } from "../../../hooks";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

//svgs
import { ExpandIcon, CollapseIcon } from "../../../components/svgs";
import {
  Body,
  Children,
  MainHolder,
  StyledText,
} from "../../../components/common/basic";
import { BackButton, FeatureHeader } from "../../../components/common";

const faq = [
  {
    title: `What is Capture & Share promo?`,
    description: `The MTN Capture & Share Promotion is a promotion which requires Pulsers to capture an image on fast playing GIF on myMTN App and send/share to win the prize captured on daily basis.`,
  },
  {
    title: `What is the promo duration?`,
    description: `It runs from February 13th to 17th 2023`,
  },
  {
    title: `Do I have to subscribe to participate in this promo?`,
    description: `No subscription required.`,
  },
  {
    title: `How do I participate in this promo?`,
    description: `Capture one (1) image and share to win the specific price as captured on the GIF.`,
  },
  {
    title: `How many times can I share captured image?`,
    description: `Share only one (1) image per day.`,
  },
  {
    title: `How do I check history of shared images?`,
    description: `Shared images are saved on customer’s profile with relevant details.`,
  },
  {
    title: `How will I know if I am a winner?`,
    description: `Winners will be notified by authorized MTN Personnel via 0244300000 and updated on the app.`,
  },
];

const PulseNChillFaq = () => {
  const { themeContext, theme } = useTheme();
  const { activeTheme } = themeContext;
  const { selectedLoyaltyData } = useLoyalty();

  const { promoData: { tailImage } = {} } = selectedLoyaltyData || {};

  const history = useHistory();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "PulseAndChillFaq",
        firebase_screen_class: "PulseAndChillFaq",
      })
    );
  }, []);
  return (
    <>
      <MainHolder>
        <Children>
          <BackButton onClick={() => history.goBack()} />
          <FeatureHeader
            image={tailImage}
            title={["Frequently", "Asked", "Questions"]}
            background='#fff'
          />
          <Body>
            <div
              style={{ boxSizing: "border-box", padding: "0 15px 30px 15px" }}
            >
              {faq.map(({ title, description }, idx) => (
                <ExpandablePanel key={idx} title={title} color={background}>
                  <StyledText
                    size={12}
                    style={{ margin: 0, fontFamily: "MTNRegular" }}
                  >
                    {description}
                  </StyledText>
                </ExpandablePanel>
              ))}
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const ExpandablePanel = ({ title, color, children }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <div
      style={{
        padding: "15px 0",
        borderBottom: "1px solid #B7BABA",
        cursor: "pointer",
      }}
    >
      <div
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <StyledText
          size={12}
          style={{ margin: 0 }}
          color={isExpanded ? color : "#000"}
        >
          {title}
        </StyledText>
        {isExpanded ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            <CollapseIcon fill={color} />
          </div>
        ) : (
          <div style={{ display: "flex", alignItems: "center" }}>
            <ExpandIcon fill={color} />
          </div>
        )}
      </div>
      {isExpanded && <div style={{ padding: "10px 0" }}>{children}</div>}
    </div>
  );
};

export default PulseNChillFaq;
